import styled from 'styled-components';

export const AccordionContainer = styled.div`
  box-shadow: ${({ dropShadowColor }) =>
    dropShadowColor ? `0px 4px 6px 0px ${dropShadowColor}` : `0px 4px 6px 0px #1f29370d`};
  border: ${({ borderWidth = 1, borderColor = '#ccc' }) => `${borderWidth}px solid ${borderColor}`};
  border-radius: ${({ borderRadius = 8 }) => `${borderRadius}px`};
  overflow: hidden;

  & .accordion-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    cursor: pointer;
    background-color: ${({ headerBgColor = 'red' }) =>
      headerBgColor && !headerBgColor.startsWith('linear-gradient') ? headerBgColor : 'transparent'};
    background-image: ${({ headerBgColor }) =>
      headerBgColor && headerBgColor.startsWith('linear-gradient') ? headerBgColor : 'none'};
    /* ACCORDION_HEADER_BACKGROUNDS (DL-037 / N39): a structured fill (gradient /
       pattern / image / GIF) resolved by the canonical buildSegmentFillCss wins via
       the background shorthand. Absent (OFF path, or a plain color header) => this
       emits nothing and the color-only longhands above are byte-identical. */
    ${({ headerFillCss }) => (headerFillCss ? `background: ${headerFillCss};` : '')}
    opacity: ${({ headerOpacity }) => headerOpacity && headerOpacity}
  }

  & .accordion-details {
    display: none;
  }

  &.expanded .accordion-details {
    display: block;
  }

  & .textContentEditable p {
    margin-bottom: 0;
    color: ${({ titleColor }) => titleColor || 'white'};
  }
`;
